import { deleteRequiredDocuments } from 'common/api/creditApplications';
import alerts from 'common/modules/alerts';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import {
    DELETE_DOCUMENT,
    DELETE_DOCUMENT_FAILURE,
    DELETE_DOCUMENT_SUCCESS,
} from '../actionTypes';
import { creditFileActions } from '../reducer';

import fetchRequiredDocumentsList from './documents/fetchRequiredDocumentsList';

export default (document) => (dispatch) => {
    const { id, credit_commercial_offer } = document;
    dispatch(creditFileActions[DELETE_DOCUMENT]());

    deleteRequiredDocuments(id)
        .then(() => {
            dispatch(creditFileActions[DELETE_DOCUMENT_SUCCESS]());
            dispatch(fetchRequiredDocumentsList(credit_commercial_offer));
            dispatch(alerts.actions.close());
        })
        .catch((error) => {
            dispatch(
                creditFileActions[DELETE_DOCUMENT_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error?.response);
        });
};
